/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Global } from '@emotion/react';
import styled from '@emotion/styled';
import { Layout, cssVar } from '@sonarsource/echoes-react';
import { Outlet, Route } from 'react-router-dom';
import {
  licenseRoutes as licenseRoutesPrivate,
  projectRoutes as projectRoutesPrivate,
} from '~feature-sca/components/routes';

/**
 * @deprecated this will be replaced by Echoes Layouts
 */
function LayoutWrapper() {
  return (
    <>
      <Global
        styles={{
          body: { overflow: 'hidden' },
          '#global-container': {
            height: '100vh',
            display: 'grid',
            'grid-template-rows': '1fr auto',
          },
          '#container': {
            overflow: 'hidden',
            display: 'grid',
            'grid-template-rows': 'auto 1fr',
          },
        }}
      />
      <TemporaryLayout>
        <Layout.ContentGrid>
          <Outlet />
        </Layout.ContentGrid>
      </TemporaryLayout>
    </>
  );
}

const TemporaryLayout = styled.div`
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  min-width: ${cssVar('layout-sizes-min-width-default')};
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-template-areas: 'content';
`;

const projectRoutes = () => <Route element={<LayoutWrapper />}>{projectRoutesPrivate}</Route>;

function licenseRoutes() {
  return <Route element={<LayoutWrapper />}>{licenseRoutesPrivate}</Route>;
}

export { licenseRoutes, projectRoutes };
